import {FiAlertTriangle, FiTrash2} from "react-icons/fi";
import { useTranslation } from "react-i18next";
import styles from "./ConfirmDeleteModal.module.css";

const ConfirmDeleteModal = ({ isOpen, onConfirm, onCancel, message, disabled, forceDelete, confirmLabel }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.iconWrap}>
              {forceDelete ? (<FiAlertTriangle className={styles.icon} aria-hidden />) : (<FiTrash2 className={styles.icon} aria-hidden />)}
          </div>
          <h3 className={styles.title}>{t("common.confirmTitle")}</h3>
        </div>

        <p className={styles.message}>{message}</p>

        <div className={styles.actions}>
          <button type="button" className={styles.cancelBtn} onClick={onCancel}>
            {t("common.cancel")}
          </button>
          <button type="button" className={styles.confirmBtn} onClick={onConfirm} disabled={disabled}>
              {confirmLabel || (forceDelete ? t("common.yesDelete") : t("common.delete"))}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
